import React from "react";
import Unauthorized from "../views/Unauthorized";

const pageAccess = ({user,type="default"}) => {

    const message = {
        header: "Contact with your administrator",
        body: "Please speak with BeTyphon Team to upgrade your <b>Basic Plan to Enterprises Plan</b> \n  Connect us Call - 1800-120-6389 Write us - support@techmet.in",
    }
    
    // Redirect to unauthorized page for Basic plan users
    if(user && user.plan === "Basic"){
        return <Unauthorized message={message} />;
    }

    return false
}

export default pageAccess;